import React, { useEffect, useState } from "react"
import { NPI, SLN } from "../helper/attribute"
import { evaluateChildrenDependency, mapAttributeDependency } from "../../shared/helpers/attribute"
import AttributeComponent from "../../shared/components/AttributeComponent"
import MobileComponent from "./MobileComponent"
import PasswordComponent from "./PasswordComponent"

const SectionComponent = (props) => {
    const [attributes, setAttributes] = useState([])
    const [mappedAttributes, setMappedAttributes] = useState([])
    const [slnAttribute, setSlnAttribute] = useState(undefined)
    const [emailAttribute, setEmailAttribute] = useState(undefined)

    useEffect(() => {
        props.setAttributes((previousState) => {
            if (previousState && previousState[props.id].length > 0) {
                const mappedAttr = mapAttributeDependency(previousState[props.id])
                setMappedAttributes(mappedAttr)
                let section = [...previousState[props.id]]
                Object.keys(mappedAttr).forEach((parentId) => {
                    mappedAttr[parentId].forEach((childAttr) => {
                        previousState[props.id].find(x => x.id == childAttr.attributeId).visible = false
                        let attrIndex = section.findIndex(x => x.id == childAttr.attributeId)
                        let attr = { ...section[attrIndex] }
                        attr.visible = false
                        section[attrIndex] = attr
                    })
                })
                previousState[props.id] = section

                const containsNpi = section.find(x => x.id == NPI)
                if (containsNpi) {
                    const sln = section.find(x => x.id == SLN)
                    const attrWithoutSln = section.filter(x => x.id != SLN)
                    setSlnAttribute(sln)
                    setAttributes(attrWithoutSln)
                } else {
                    setAttributes(section)
                    setSlnAttribute(undefined)
                }

                setEmailAttribute(section.find(x => x.id == "email"))
                return previousState
            }
        })
    }, [props.setAttributes, props.id])

    const onChangeListValue = (parentId, parentValue) => {
        evaluateChildrenDependency(parentId, parentValue, props.id,
            attributes, mappedAttributes, setAttributes, props.setAttributes)
    }

    const onEmailChange = (email) => {
        props.onEmailChange(email)
    }

    return (
        <div className="section details">
            {props.name != null && props.name != '' &&
                <p className="section-name center-items">{props.name}</p>
            }
            {attributes.map((attribute) => {
                if (attribute.visible && attribute.id != "email") {
                    return <div>
                        <AttributeComponent id={attribute.id}
                            inputTypeId={attribute.inputTypeId}
                            label={attribute.label}
                            name={attribute.name}
                            defaultValue={attribute.defaultValue}
                            attributeChoices={attribute.attributeChoices}
                            numericMin={attribute.numericMin}
                            numericMax={attribute.numericMax}
                            required={attribute.required}
                            requiredForLabel={attribute.required}
                            attributeValidationRules={attribute.attributeValidationRules}
                            placeholderText={attribute.placeholderText}
                            setAttributes={props.setAttributes}
                            sectionId={props.id}
                            highlightErrors={props.highlightErrors}
                            countryIsoCode={props.countryIsoCode}
                            onChangeListValue={onChangeListValue}
                            acknowledge={true}
                            disableValues={true}
                            isUnique={attribute.isUnique}
                            randomizeChoices={attribute.randomizeChoices}
                            checkUniqueValue={props.checkUniqueValue}
                            autocomplete={attribute.id == SLN ? 'do-not-autofill' : ''}
                            onEditPanelistTool={false}
                            setUniqueAttributes={props.setUniqueAttributes}
                            checkUniqueAttributesValidity={props.checkUniqueAttributesValidity}
                            isShgRegistration={props.isShgRegistration}
                        />
                    </div>
                }
            })}
            {props.id == 3 && (
                <div>
                    <PasswordComponent
                        setPassword={props.setPassword}
                        highlightErrors={props.highlightErrors} />
                    {
                        emailAttribute && (
                            <AttributeComponent id={emailAttribute.id}
                                inputTypeId={emailAttribute.inputTypeId}
                                label={emailAttribute.label}
                                name={emailAttribute.name}
                                defaultValue={emailAttribute.defaultValue}
                                attributeChoices={emailAttribute.attributeChoices}
                                numericMin={emailAttribute.numericMin}
                                numericMax={emailAttribute.numericMax}
                                required={emailAttribute.required}
                                requiredForLabel={emailAttribute.required}
                                attributeValidationRules={emailAttribute.attributeValidationRules}
                                setAttributes={props.setAttributes}
                                warningDataToolTip={emailAttribute.dataToolTip}
                                highlightWarning={true}
                                sectionId={props.id}
                                onChangeListValue={onChangeListValue}
                                onEmailChange={onEmailChange}
                                acknowledge={true}
                                isShgRegistration={props.isShgRegistration}
                            />)
                    }
                    <MobileComponent
                        setSendEmailAndSms={props.setSendEmailAndSms}
                        setMobileNumber={props.setMobileNumber}
                        highlightErrors={props.highlightErrors}
                        isShgRegistration={props.isShgRegistration}
                        countryIsoCode={props.countryIsoCode}
                    />
                </div>
            )}
            {slnAttribute && (
                <div>
                    <div className="separator"></div>
                    <AttributeComponent id={slnAttribute.id}
                        inputTypeId={slnAttribute.inputTypeId}
                        label={slnAttribute.label}
                        name={slnAttribute.name}
                        attributeChoices={slnAttribute.attributeChoices}
                        numericMin={slnAttribute.numericMin}
                        numericMax={slnAttribute.numericMax}
                        attributeValidationRules={slnAttribute.attributeValidationRules}
                        placeholderText={slnAttribute.placeholderText}
                        required={slnAttribute.required}
                        requiredForLabel={slnAttribute.required}
                        setAttributes={props.setAttributes}
                        sectionId={props.id}
                        highlightErrors={props.highlightErrors}
                        defaultValue={slnAttribute.defaultValue}
                        acknowledge={true}
                        autocomplete="do-not-autofill"
                    />
                </div>
            )}
        </div>
    )
}
export default SectionComponent